import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { MotorBodyStyleForm } from "./components/motorBodyStyleForm";
import { fetchDataById, putData } from "../../../services";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const EditMotorBodyStyle = () => {

  const navigate = useNavigate();
  const params = useParams();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const [bodyStyleData, setBodyStyleData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/motor/bodystyle/${paramId}`).then(
            (res) => {
              setBodyStyleData((prevData) => ({
                ...prevData,
                ...res?.data,
              }));
            }
          );
        } catch (error) {
          console.error("Error Fetching:",error);
          showSnackbar(error?.response?.data?.message, "error");
        } finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  const handleUpdateBodyStyle = async (bodyStyleData) => {
    setCircleLoading(true);
    try {
      const bodyStyleUpdateData = {
        name: bodyStyleData.name,
        motorBodyTypeId: bodyStyleData.motorBodyType?.value,
        isActive: bodyStyleData.active,
      };
      const response = await putData(
        `/reference/motor/bodystyle/${bodyStyleData.id}`,
        bodyStyleUpdateData
      );

      if (response?.success) {
        showSnackbar(response?.message,"success");
        navigate("/motor-master/motor-bodyStyle");
      }
    } catch (error) {
      console.error("Error Updating",error);
      showSnackbar(error?.response?.data?.message || "Network Error","error");
    }finally{
      setCircleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/motor-master/motor-bodyStyle")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Body Style details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Body Style details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorBodyStyleForm
            onsubmit={handleUpdateBodyStyle}
            editBodyStyleData={bodyStyleData}
          />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditMotorBodyStyle;
